import { render, staticRenderFns } from "./FullPageStudentDashboard.vue?vue&type=template&id=4c922cbc&"
import script from "./FullPageStudentDashboard.vue?vue&type=script&lang=js&"
export * from "./FullPageStudentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FullPageStudentDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports